// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard/default';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

const config = {
  fontFamily: `'Public Sans', sans-serif`,
  presetColor: 'default',
  darkModeStyle: 'discord-dark'
};

export default config;
